import { createFileRoute } from '@tanstack/react-router'
import AdaptiveRoutingTab from '@/components/organisms/AdaptiveRoutingTab'

export const Route = createFileRoute('/_authenticated/phone/routing')({
  component: AdaptiveRoutingTab,
})
